import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="revenue-calculator"
export default class extends Controller {
  static targets = ["revenue", "ratio"]
  
  connect() {
    // Set up initial calculations on page load
    this.calculateAllRatios()
    
    // Add event listeners to all revenue inputs for real-time updates
    this.revenueTargets.forEach(input => {
      input.addEventListener('input', this.handleRevenueInput.bind(this))
      input.addEventListener('change', this.handleRevenueInput.bind(this))
    })
  }

  handleRevenueInput(event) {
    // Extract the year from the input ID
    const year = event.target.id.match(/\d{4}/)[0]
    
    // When a revenue input changes:
    // 1. If this is a current year, update its own ratio
    // 2. If this is a previous year, update the next year's ratio
    
    // Check if this year has a ratio field that depends on the previous year
    const currentYearInt = parseInt(year)
    const nextYear = (currentYearInt + 1).toString()
    
    // Calculate ratio for the next year (if it exists)
    this.calculateRatio(year, nextYear)
    
    // Calculate ratio for the current year (based on the previous year)
    const prevYear = (currentYearInt - 1).toString()
    this.calculateRatio(prevYear, year)
  }

  calculateAllRatios() {
    // Calculate ratio for each pair of years (2018-2019, 2019-2020, etc.)
    this.calculateRatio('2018', '2019')
    this.calculateRatio('2019', '2020')
    this.calculateRatio('2020', '2021')
    this.calculateRatio('2021', '2022')
    this.calculateRatio('2022', '2023')
  }

  calculateRatio(previousYear, currentYear) {
    const previousInput = document.getElementById(`startup_profit_revenue_${previousYear}`)
    const currentInput = document.getElementById(`startup_profit_revenue_${currentYear}`)
    const ratioInput = document.getElementById(`startup_profit_revenue_ratio_${currentYear}`)
    
    if (previousInput && currentInput && ratioInput) {
      const previousValue = parseFloat(previousInput.value) || 0
      const currentValue = parseFloat(currentInput.value) || 0
      
      if (previousValue > 0) {
        // Calculate percentage growth: ((current - previous) / previous) * 100
        // Example: 100 to 200 should be 100% growth
        const growthAmount = currentValue - previousValue
        const growthPercentage = (growthAmount / previousValue) * 100
        ratioInput.value = growthPercentage.toFixed(2)
      } else if (currentValue > 0 && previousValue === 0) {
        // If previous is 0 and current has value, set to 100% as default growth value
        ratioInput.value = "100.00"
      } else {
        // If both are 0 or other edge cases
        ratioInput.value = "0.00"
      }
    }
  }
}
